/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiHttpBody } from '../../models/api-http-body';

export interface UserServiceGenerateUserGachaImage$Params {
  userUuid: string;
  gachaId: string;
  discordId?: string;
}

export function userServiceGenerateUserGachaImage(http: HttpClient, rootUrl: string, params: UserServiceGenerateUserGachaImage$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiHttpBody>> {
  const rb = new RequestBuilder(rootUrl, userServiceGenerateUserGachaImage.PATH, 'get');
  if (params) {
    rb.path('userUuid', params.userUuid, {});
    rb.path('gachaId', params.gachaId, {});
    rb.query('discordId', params.discordId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiHttpBody>;
    })
  );
}

userServiceGenerateUserGachaImage.PATH = '/api/v3/gateway/user/{userUuid}/gacha/{gachaId}/image';
